module.exports = __webpack_public_path__ + "static/media/dislike.d4ec34e8.svg";